import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourcesService } from '../../user/resources.service';
import { ModalsState, ReportModalService } from './report-modal.service';

@Component({
  selector: 'app-span-progress-report',
  templateUrl: './span-progress-report.component.html',
  styleUrls: ['./span-progress-report.component.scss'],
  standalone: false,
})
export class SpanProgressReportComponent implements OnInit {
  ifs$: Observable<string | null>;
  modalState$: Observable<ModalsState>;

  constructor(
    private resourcesService: ResourcesService,
    private reportModalService: ReportModalService,
  ) {}

  ngOnInit() {
    this.ifs$ = this.resourcesService
      .getSelectedResource$()
      .pipe(map((resource) => (resource ? resource.value : null)));
    this.modalState$ = this.reportModalService.getModalState$();
  }

  closeModal(modalName: keyof ModalsState) {
    const newState = {} as Partial<ModalsState>;
    newState[modalName] = { open: false };
    this.reportModalService.setModalState(newState);
  }
}
